import {ReactNode, ComponentType} from 'react'
import WithModal, {WithModalProps} from './WithModal'

export interface ModalFormBaseProps {
  initialValues?: any
  onAfterSubmit: () => void
  onCancel: () => void
}

type ModalWithFormProps<FormProps extends ModalFormBaseProps> = Omit<
  WithModalProps,
  'renderModalBody'
> & {
  Form: ComponentType<FormProps>
  initialValues?: FormProps['initialValues']
  onSubmit?: () => void
  children?: ReactNode
}

function ModalWithForm<FormProps extends ModalFormBaseProps>({
  initialValues,
  onSubmit = () => {},
  Form,
  children,
  ...modalProps
}: ModalWithFormProps<FormProps>) {
  return (
    <WithModal
      {...modalProps}
      renderModalBody={(closeModal) => (
        <Form
          {...({
            initialValues,
            onAfterSubmit: () => {
              closeModal()
              onSubmit()
            },
            onCancel: closeModal,
          } as FormProps)}
        />
      )}
    >
      {children}
    </WithModal>
  )
}

export default ModalWithForm
